
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gA0pS", function(module, exports) {

$parcel$export(module.exports, "ensurePluginsPageContainer", () => $c12054d760b5417f$export$455c1b7fa63f34db);
$parcel$export(module.exports, "renderPluginList", () => $c12054d760b5417f$export$7ab05cbc81677eee);
$parcel$export(module.exports, "appPluginRender", () => $c12054d760b5417f$export$b0a4693d263ab2bc);

var $ePZMh = parcelRequire("ePZMh");

var $2sA8K = parcelRequire("2sA8K");

var $12U9u = parcelRequire("12U9u");

var $e6rpZ = parcelRequire("e6rpZ");

var $bp6lf = parcelRequire("bp6lf");

var $aJO1s = parcelRequire("aJO1s");

var $i1ZxU = parcelRequire("i1ZxU");

var $jJLVf = parcelRequire("jJLVf");

var $aWzLm = parcelRequire("aWzLm");

var $bLvxX = parcelRequire("bLvxX");

var $grJqE = parcelRequire("grJqE");

var $58K1u = parcelRequire("58K1u");

var $4D2XJ = parcelRequire("4D2XJ");

var $20IIa = parcelRequire("20IIa");
const $c12054d760b5417f$export$455c1b7fa63f34db = function() {
    let container = (0, $12U9u.qS)('#app_plugin_container');
    if (container) return container;
    container = document.createElement('div');
    container.classList.add('app-container', 'app-page-container', 'app-plugin-container', 'hidden');
    container.id = 'app_plugin_container';
    container.innerHTML = `
    <div class="app-container-inner app-container-inner-no-top-bar">
      <div class="scrollable" id="app_plugin_scroll">
        <div class="app-settings-list-inner app-plugin-list-inner inner" id="app_plugin_list_inner">
          <div class="plugin-section app-account-section">
            <div class="list-title-sub">${(0, $4D2XJ.t)('plugins.pluginsTitle')}</div>
            <div class="plugin-list" id="plugin_list"></div>
          </div>
          <div class="app-account-section plugin-flow-wrapper" id="plugin_flow_wrapper"></div>
        </div>
      </div>
    </div>
  `;
    (0, $12U9u.qS)('#app_content')?.appendChild(container);
    (0, $grJqE.ensurePluginFlow)();
    return container;
};
const $c12054d760b5417f$var$setButtonLoading = function(button, loading) {
    if (!button) return;
    button.disabled = Boolean(loading);
    button.classList.toggle('button-loading', Boolean(loading));
};
const $c12054d760b5417f$var$getPluginTypeId = function(pluginItem) {
    if (pluginItem?.custom || pluginItem?.icon === 'custom') return 'custom';
    return String(pluginItem?.icon || 'custom').replace(/[^a-z0-9-]/gi, '').toLowerCase() || 'custom';
};
const $c12054d760b5417f$export$7798eb0f6c33f4c0 = function(pluginItem) {
    const connected = pluginItem.connection?.status === 'connected';
    const readOnly = (0, $ePZMh.viewingOtherUser)();
    const pluginTypeId = $c12054d760b5417f$var$getPluginTypeId(pluginItem);
    const card = document.createElement('div');
    card.classList.add('plugin-card');
    card.dataset.pluginId = pluginTypeId;
    if (connected) card.classList.add('connected');
    const icon = document.createElement('div');
    icon.classList.add('plugin-icon', `plugin-icon-${pluginTypeId}`);
    if (pluginItem.toolkitSlug) icon.style.backgroundImage = `url("https://logos.composio.dev/api/${encodeURIComponent(pluginItem.toolkitSlug)}")`;
    icon.setAttribute('aria-hidden', 'true');
    card.appendChild(icon);
    const body = document.createElement('div');
    body.classList.add('plugin-body');
    card.appendChild(body);
    const titleRow = document.createElement('div');
    titleRow.classList.add('plugin-title-row');
    body.appendChild(titleRow);
    const title = document.createElement(connected ? 'input' : 'div');
    title.classList.add('plugin-title');
    if (connected) {
        title.type = 'text';
        title.readOnly = readOnly;
        title.value = pluginItem.connection?.name || pluginItem.name;
        title.maxLength = 80;
        title.setAttribute('aria-label', (0, $4D2XJ.t)('plugins.connectionName'));
        const saveName = async function() {
            if (readOnly) return;
            const nextName = title.value.replace(/\s+/g, ' ').trim();
            if (!nextName || nextName === (pluginItem.connection?.name || pluginItem.name)) {
                title.value = pluginItem.connection?.name || pluginItem.name;
                return;
            }
            const loadingNotification = (0, $aJO1s.notification).showLoading((0, $4D2XJ.t)('common.saving'));
            title.disabled = true;
            try {
                await (0, $aWzLm.updatePluginSettings)(pluginItem.connection.connectionId, {
                    name: nextName
                });
                pluginItem.connection.name = nextName;
                (0, $bLvxX.renderPluginsChatControl)();
                (0, $aJO1s.notification).update((0, $4D2XJ.t)('notifications.saved'), loadingNotification, 'success');
            } catch (error) {
                title.value = pluginItem.connection?.name || pluginItem.name;
                (0, $aJO1s.notification).update(error.message || (0, $4D2XJ.t)('plugins.updateFailed'), loadingNotification, 'error', true);
            }
            title.disabled = false;
        };
        title.addEventListener('change', saveName);
        title.addEventListener('keydown', (event)=>{
            if (event.key === 'Enter') {
                event.preventDefault();
                title.blur();
            }
        });
    } else title.textContent = pluginItem.name;
    titleRow.appendChild(title);
    if (connected) {
        const controls = document.createElement('div');
        controls.classList.add('plugin-controls');
        card.appendChild(controls);
        const writeEnabled = pluginItem.connection?.allowWriteActions === true;
        const accessLabel = (0, $4D2XJ.t)(writeEnabled ? 'plugins.readWriteStatus' : 'plugins.readOnlyStatus');
        const accessIndicator = document.createElement('button');
        accessIndicator.type = 'button';
        accessIndicator.classList.add('plugin-access-indicator', writeEnabled ? 'read-write' : 'read-only');
        accessIndicator.setAttribute('aria-label', accessLabel);
        accessIndicator.dataset.tooltip = accessLabel;
        accessIndicator.dataset.tooltipClick = 'no-hover';
        controls.appendChild(accessIndicator);
        const disconnectButton = document.createElement('button');
        disconnectButton.type = 'button';
        disconnectButton.disabled = readOnly;
        disconnectButton.classList.add('button-delete');
        disconnectButton.setAttribute('aria-label', (0, $4D2XJ.t)('plugins.disconnect'));
        disconnectButton.dataset.tooltip = (0, $4D2XJ.t)('plugins.disconnect');
        disconnectButton.dataset.tooltipClick = 'no-hover';
        controls.appendChild(disconnectButton);
        disconnectButton.addEventListener('click', async ()=>{
            if (readOnly) return;
            (0, $bp6lf.confirm)((0, $4D2XJ.t)('plugins.disconnectConfirm', {
                pluginName: pluginItem.name
            }), async ()=>{
                $c12054d760b5417f$var$setButtonLoading(disconnectButton, true);
                const list = card.parentElement;
                const nextCard = card.nextSibling;
                const loadingNotification = (0, $aJO1s.notification).showLoading((0, $4D2XJ.t)('plugins.deleting'));
                let emptyState = null;
                card.remove();
                if (list && !list.querySelector('.plugin-card')) {
                    emptyState = document.createElement('div');
                    emptyState.classList.add('plugin-empty', 'list-text-sub');
                    emptyState.textContent = (0, $4D2XJ.t)('plugins.noPlugins');
                    list.appendChild(emptyState);
                }
                try {
                    await (0, $aWzLm.disconnectPlugin)(pluginItem.connection.connectionId);
                    (0, $bLvxX.renderPluginsChatControl)();
                    (0, $aJO1s.notification).update((0, $4D2XJ.t)('notifications.deleted'), loadingNotification, 'success');
                    (0, $e6rpZ.activity).log((0, $e6rpZ.activity).activityTypes.pluginDelete, (0, $20IIa.getPluginActivityMetadata)(pluginItem));
                } catch (error) {
                    emptyState?.remove();
                    if (list) list.insertBefore(card, nextCard?.parentElement === list ? nextCard : null);
                    (0, $aJO1s.notification).update(error.message || (0, $4D2XJ.t)('plugins.disconnectFailed'), loadingNotification, 'error', true);
                    $c12054d760b5417f$var$setButtonLoading(disconnectButton, false);
                }
            });
        });
    }
    return card;
};
const $c12054d760b5417f$export$7ab05cbc81677eee = async function() {
    const list = (0, $12U9u.qS)('#plugin_list');
    if (!list) return;
    list.innerHTML = `<div class="plugin-empty list-text-sub">${(0, $4D2XJ.t)('common.loading')}</div>`;
    try {
        const pluginList = await (0, $aWzLm.getPlugins)({
            force: true
        });
        list.innerHTML = '';
        let connectionCount = 0;
        pluginList.forEach((pluginItem)=>{
            const connectionList = Array.isArray(pluginItem.connectionList) ? pluginItem.connectionList : [];
            connectionList.forEach((connection)=>{
                connectionCount += 1;
                list.appendChild($c12054d760b5417f$export$7798eb0f6c33f4c0({
                    ...pluginItem,
                    connection: connection
                }));
            });
        });
        if (connectionCount === 0) {
            const emptyState = document.createElement('div');
            emptyState.classList.add('plugin-empty', 'list-text-sub');
            emptyState.textContent = (0, $4D2XJ.t)('plugins.noPlugins');
            list.appendChild(emptyState);
        }
        requestAnimationFrame(()=>(0, $i1ZxU.tooltip).addNewEventHandlers());
    } catch (error) {
        list.innerHTML = '';
        const errorState = document.createElement('div');
        errorState.classList.add('plugin-empty', 'list-text-sub');
        errorState.textContent = error.message || (0, $4D2XJ.t)('plugins.loadFailed');
        list.appendChild(errorState);
    }
};
const $c12054d760b5417f$export$b0a4693d263ab2bc = function(goBack = false) {
    (0, $jJLVf.appCleanUI)();
    const container = $c12054d760b5417f$export$455c1b7fa63f34db();
    (0, $12U9u.qS)('#app_sidebar_add_icon').classList.remove('inactive');
    container.classList.remove('hidden');
    (0, $58K1u.renderSettingsSubnav)('/app/plugins/', '#app_plugin_container');
    $c12054d760b5417f$export$7ab05cbc81677eee();
    (0, $grJqE.renderPluginFlow)();
    if (!goBack) (0, $2sA8K.pushAppState)({}, '', '/app/plugins/');
};

});
parcelRegister("grJqE", function(module, exports) {

$parcel$export(module.exports, "ensurePluginFlow", () => $bf9268343cad7907$export$fa22955b624062f4);
$parcel$export(module.exports, "showPluginFlowError", () => $bf9268343cad7907$export$2c2cf027c588e49a);
$parcel$export(module.exports, "renderPluginFlow", () => $bf9268343cad7907$export$d5cdff876b53417);

var $ePZMh = parcelRequire("ePZMh");

var $12U9u = parcelRequire("12U9u");

var $e6rpZ = parcelRequire("e6rpZ");

var $4BV0m = parcelRequire("4BV0m");

var $aWzLm = parcelRequire("aWzLm");

var $4D2XJ = parcelRequire("4D2XJ");

var $hTT6T = parcelRequire("hTT6T");

var $knwcN = parcelRequire("knwcN");

var $20IIa = parcelRequire("20IIa");

var $2EYvU = parcelRequire("2EYvU");

var $7zs24 = parcelRequire("7zs24");
const { CUSTOM_MCP_MAX_HEADERS: $bf9268343cad7907$var$CUSTOM_MCP_MAX_HEADERS, normalizeCustomHeaders: $bf9268343cad7907$var$normalizeCustomHeaders } = (0, (/*@__PURE__*/$parcel$interopDefault($7zs24)));
const { CUSTOM_MCP_TOOL_ACCESS: $bf9268343cad7907$var$CUSTOM_MCP_TOOL_ACCESS, getCustomMcpToolDeclaredAccess: $bf9268343cad7907$var$getCustomMcpToolDeclaredAccess } = (0, (/*@__PURE__*/$parcel$interopDefault($2EYvU)));
const $bf9268343cad7907$var$CUSTOM_PLUGIN_ID = 'custom_mcp';
const $bf9268343cad7907$var$CUSTOM_OAUTH_SETUP_STORAGE_KEY = 'customPluginOAuthSetup';
let $bf9268343cad7907$var$selectedPlugin = null;
let $bf9268343cad7907$var$pluginCatalog = [];
let $bf9268343cad7907$var$customOAuthSetupId = '';
let $bf9268343cad7907$var$customHeaderRowId = 0;
let $bf9268343cad7907$var$customInspectionRevision = 0;
const $bf9268343cad7907$var$inferInputKey = function(tool) {
    const propertyList = Array.isArray(tool?.inputPropertyList) ? tool.inputPropertyList : [];
    return [
        'query',
        'search',
        'text',
        'input',
        'q'
    ].find((key)=>propertyList.includes(key)) || propertyList[0] || '';
};
const $bf9268343cad7907$var$getSafeIconName = function(icon) {
    return String(icon || 'custom').replace(/[^a-z0-9-]/gi, '').toLowerCase() || 'custom';
};
const $bf9268343cad7907$var$createPluginLogo = function(pluginItem) {
    const logo = document.createElement('span');
    logo.classList.add('plugin-option-logo', `plugin-option-logo-${$bf9268343cad7907$var$getSafeIconName(pluginItem.icon)}`);
    logo.setAttribute('aria-hidden', 'true');
    if (pluginItem.toolkitSlug) logo.style.backgroundImage = `url("https://logos.composio.dev/api/${encodeURIComponent(pluginItem.toolkitSlug)}")`;
    else if (![
        'custom',
        'drive',
        'figma',
        'github',
        'gmail',
        'atlassian-rovo',
        'microsoft-365',
        'notion',
        'slack',
        'jira',
        'confluence',
        'outlook',
        'onedrive',
        'excel',
        'google-docs',
        'google-sheets',
        'google-slides'
    ].includes($bf9268343cad7907$var$getSafeIconName(pluginItem.icon))) logo.textContent = (pluginItem.name || '?').slice(0, 1);
    return logo;
};
const $bf9268343cad7907$export$fa22955b624062f4 = function() {
    const container = (0, $12U9u.qS)('#plugin_flow_wrapper');
    if (!container || container.dataset.initialized === 'true') return container;
    container.innerHTML = `
    <section class="plugin-picker-section">
      <div class="plugin-section-heading">
        <div class="list-title-sub">${(0, $4D2XJ.t)('plugins.connectTo')}</div>
        <input class="plugin-catalog-search" id="plugin_catalog_search" type="text" autocomplete="off" aria-label="${(0, $4D2XJ.t)('plugins.searchPlaceholder')}" placeholder="${(0, $4D2XJ.t)('plugins.searchPlaceholder')}">
        <button class="plugin-select-another button-text hidden" type="button" id="plugin_selection_edit">${(0, $4D2XJ.t)('plugins.selectAnother')}</button>
      </div>
      <div class="list-text-sub">${(0, $4D2XJ.t)('plugins.copy')}</div>
      <div class="plugin-selected-summary hidden" id="plugin_selected_summary"></div>
      <div class="plugin-option-grid" id="plugin_option_grid">
        <div class="plugin-empty list-text-sub">${(0, $4D2XJ.t)('common.loading')}</div>
      </div>
    </section>

    <form class="plugin-details-form hidden" id="plugin_details_form">
      <section class="plugin-fields-section hidden" id="plugin_fields_section">
        <div class="input-label-top plugin-name-field">
          <label for="plugin_connection_name">${(0, $4D2XJ.t)('plugins.customName')}</label>
          <input id="plugin_connection_name" type="text" maxlength="80" required>
        </div>

        <div class="hidden" id="custom_mcp_fields">
          <div class="input-label-top">
            <label for="custom_mcp_endpoint">${(0, $4D2XJ.t)('plugins.customEndpoint')}</label>
            <input id="custom_mcp_endpoint" type="url" placeholder="https://mcp.example.com/mcp" required>
            <div class="plugin-field-help">${(0, $4D2XJ.t)('plugins.endpointHelp')}</div>
          </div>

          <div class="plugin-advanced-fields" id="custom_mcp_advanced_fields">
            <div class="input-label-top">
              <label for="custom_mcp_auth_type">${(0, $4D2XJ.t)('plugins.customAuthentication')}</label>
              <div class="select-wrapper">
                <select id="custom_mcp_auth_type">
                  <option value="none">${(0, $4D2XJ.t)('plugins.customNoAuthentication')}</option>
                  <option value="bearer">${(0, $4D2XJ.t)('plugins.customBearerToken')}</option>
                  <option value="oauth">${(0, $4D2XJ.t)('plugins.customOAuth')}</option>
                </select>
              </div>
            </div>
            <div class="input-label-top hidden" id="custom_mcp_token_container">
              <label for="custom_mcp_token">${(0, $4D2XJ.t)('plugins.customAccessToken')}</label>
              <input id="custom_mcp_token" type="password" autocomplete="off">
            </div>
            <div class="custom-mcp-oauth-fields hidden" id="custom_mcp_oauth_fields">
              <div class="input-label-top">
                <label for="custom_mcp_oauth_client_id">${(0, $4D2XJ.t)('plugins.customOAuthClientId')}</label>
                <input id="custom_mcp_oauth_client_id" type="text" maxlength="1000" autocomplete="off">
              </div>
              <div class="input-label-top">
                <label for="custom_mcp_oauth_client_secret">${(0, $4D2XJ.t)('plugins.customOAuthClientSecret')}</label>
                <input id="custom_mcp_oauth_client_secret" type="password" maxlength="4000" autocomplete="off">
              </div>
            </div>
          </div>

          <div class="plugin-advanced-fields" id="custom_mcp_headers_section">
            <div class="plugin-field-label">${(0, $4D2XJ.t)('plugins.customHeaders')}</div>
            <div class="plugin-field-help">${(0, $4D2XJ.t)('plugins.customHeadersHelp')}</div>
            <div class="custom-mcp-header-list" id="custom_mcp_header_list"></div>
            <button class="button button-secondary custom-mcp-add-header" type="button" id="custom_mcp_add_header">${(0, $4D2XJ.t)('plugins.customAddHeader')}</button>
          </div>

          <div class="custom-mcp-form-actions">
            <button class="button button-primary" type="button" id="custom_mcp_inspect">${(0, $4D2XJ.t)('plugins.customCheckConnection')}</button>
          </div>
          <div class="custom-mcp-tool-review hidden" id="custom_mcp_tool_review">
            <div class="list-title-sub">${(0, $4D2XJ.t)('plugins.customPermissions')}</div>
            <div class="custom-mcp-tool-list" id="custom_mcp_tool_list"></div>
            <div class="custom-mcp-unspecified-access hidden" id="custom_mcp_unspecified_access">
              <div class="title">${(0, $4D2XJ.t)('plugins.customUnspecifiedTitle')}</div>
              <div class="description">${(0, $4D2XJ.t)('plugins.customUnspecifiedCopy')}</div>
              <div class="segmented-control-container plugin-access-toggle">
                <input type="radio" name="custom_mcp_unspecified_access" id="custom_mcp_unspecified_read" value="read" checked>
                <label for="custom_mcp_unspecified_read">${(0, $4D2XJ.t)('plugins.customTreatAsRead')}</label>
                <input type="radio" name="custom_mcp_unspecified_access" id="custom_mcp_unspecified_write" value="write">
                <label for="custom_mcp_unspecified_write">${(0, $4D2XJ.t)('plugins.customTreatAsWrite')}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="plugin-access-fields hidden" id="plugin_access_fields">
          <div class="plugin-field-label">${(0, $4D2XJ.t)('plugins.accessTitle')}</div>
          <div class="segmented-control-container plugin-access-toggle">
            <input type="radio" name="plugin_access" id="plugin_access_read" value="read" checked>
            <label for="plugin_access_read">${(0, $4D2XJ.t)('plugins.readOnly')}</label>
            <input type="radio" name="plugin_access" id="plugin_access_write" value="write">
            <label for="plugin_access_write">${(0, $4D2XJ.t)('plugins.readWrite')}</label>
          </div>
          <div class="plugin-access-capabilities" id="plugin_access_capabilities"></div>
        </div>
      </section>

      <div class="plugin-form-actions">
        <button class="button button-primary hidden" type="submit" id="custom_mcp_connect" disabled>${(0, $4D2XJ.t)('plugins.connect')}</button>
        <button class="button button-primary hidden" type="submit" id="plugin_connect">${(0, $4D2XJ.t)('plugins.connectButton')}</button>
      </div>
    </form>
    <div class="plugin-flow-error hidden" id="plugin_flow_error" role="alert"></div>
  `;
    container.dataset.initialized = 'true';
    $bf9268343cad7907$var$initPluginForm();
    return container;
};
const $bf9268343cad7907$export$2c2cf027c588e49a = function(message = '') {
    const error = (0, $12U9u.qS)('#plugin_flow_error');
    if (!error) return;
    error.textContent = message;
    error.classList.toggle('hidden', !message);
};
const $bf9268343cad7907$var$getCustomHeaderList = function() {
    return [
        ...document.querySelectorAll('.custom-mcp-header-row')
    ].map((row)=>({
            name: row.querySelector('[data-header-name]').value,
            value: row.querySelector('[data-header-value]').value
        }));
};
const $bf9268343cad7907$var$customConnectionErrorMessage = function(error) {
    const keys = {
        PLUGIN_TOKEN_KEY_NOT_CONFIGURED: 'plugins.customCredentialStorageUnavailable',
        PLUGINS_TOKEN_KEY_NOT_CONFIGURED: 'plugins.customCredentialStorageUnavailable',
        CUSTOM_MCP_HEADERS_INVALID: 'plugins.customHeadersInvalid',
        CUSTOM_MCP_HEADERS_RESERVED: 'plugins.customHeadersReserved',
        CUSTOM_MCP_HEADERS_DUPLICATE: 'plugins.customHeadersDuplicate',
        CUSTOM_MCP_HEADERS_LIMIT: 'plugins.customHeadersLimit'
    };
    return keys[error?.message] ? (0, $4D2XJ.t)(keys[error.message]) : null;
};
const $bf9268343cad7907$var$validateCustomHeaders = function() {
    try {
        $bf9268343cad7907$var$normalizeCustomHeaders($bf9268343cad7907$var$getCustomHeaderList());
        return true;
    } catch (error) {
        $bf9268343cad7907$export$2c2cf027c588e49a($bf9268343cad7907$var$customConnectionErrorMessage(error) || (0, $4D2XJ.t)('plugins.customCheckFailed'));
        return false;
    }
};
const $bf9268343cad7907$var$syncCustomHeaderButton = function() {
    const button = (0, $12U9u.qS)('#custom_mcp_add_header');
    if (button) button.disabled = $bf9268343cad7907$var$getCustomHeaderList().length >= $bf9268343cad7907$var$CUSTOM_MCP_MAX_HEADERS;
};
const $bf9268343cad7907$var$customHeadersChanged = function() {
    $bf9268343cad7907$var$clearCustomOAuthSetup();
    $bf9268343cad7907$var$resetCustomInspection();
    $bf9268343cad7907$var$syncCustomHeaderButton();
};
const $bf9268343cad7907$var$addCustomHeaderRow = function() {
    if ($bf9268343cad7907$var$getCustomHeaderList().length >= $bf9268343cad7907$var$CUSTOM_MCP_MAX_HEADERS) return;
    const id = ++$bf9268343cad7907$var$customHeaderRowId;
    const row = document.createElement('div');
    row.classList.add('custom-mcp-header-row');
    row.innerHTML = `
    <div class="input-label-top">
      <label for="custom_mcp_header_name_${id}">${(0, $4D2XJ.t)('plugins.customHeaderName')}</label>
      <input id="custom_mcp_header_name_${id}" data-header-name type="text" maxlength="100" autocomplete="off" autocapitalize="none" spellcheck="false" placeholder="x-workspace-slug">
    </div>
    <div class="input-label-top">
      <label for="custom_mcp_header_value_${id}">${(0, $4D2XJ.t)('plugins.customHeaderValue')}</label>
      <input id="custom_mcp_header_value_${id}" data-header-value type="password" maxlength="8192" autocomplete="off" spellcheck="false">
    </div>
    <button class="button button-secondary" type="button">${(0, $4D2XJ.t)('plugins.customRemoveHeader')}</button>
  `;
    row.addEventListener('input', $bf9268343cad7907$var$customHeadersChanged);
    row.querySelector('button').addEventListener('click', ()=>{
        row.remove();
        $bf9268343cad7907$var$customHeadersChanged();
        (0, $12U9u.qS)('#custom_mcp_add_header')?.focus();
    });
    (0, $12U9u.qS)('#custom_mcp_header_list').appendChild(row);
    $bf9268343cad7907$var$customHeadersChanged();
    row.querySelector('input').focus();
};
const $bf9268343cad7907$var$getCustomConnectionDetails = function() {
    const selectedAuthType = (0, $12U9u.qS)('#custom_mcp_auth_type')?.value;
    const authType = [
        'bearer',
        'oauth'
    ].includes(selectedAuthType) ? selectedAuthType : 'none';
    return {
        name: (0, $12U9u.qS)('#plugin_connection_name')?.value || '',
        endpoint: (0, $12U9u.qS)('#custom_mcp_endpoint')?.value || '',
        authType: authType,
        headerList: $bf9268343cad7907$var$getCustomHeaderList(),
        accessToken: authType === 'bearer' ? (0, $12U9u.qS)('#custom_mcp_token')?.value || '' : '',
        oauthClientId: authType === 'oauth' ? (0, $12U9u.qS)('#custom_mcp_oauth_client_id')?.value || '' : '',
        oauthClientSecret: authType === 'oauth' ? (0, $12U9u.qS)('#custom_mcp_oauth_client_secret')?.value || '' : '',
        oauthSetupId: authType === 'oauth' ? $bf9268343cad7907$var$customOAuthSetupId : ''
    };
};
const $bf9268343cad7907$var$getPendingCustomOAuthSetup = function() {
    try {
        const value = JSON.parse(window.sessionStorage.getItem($bf9268343cad7907$var$CUSTOM_OAUTH_SETUP_STORAGE_KEY) || 'null');
        return value?.setupId && value?.endpoint && Array.isArray(value?.toolList) ? value : null;
    } catch (_error) {
        window.sessionStorage.removeItem($bf9268343cad7907$var$CUSTOM_OAUTH_SETUP_STORAGE_KEY);
        return null;
    }
};
const $bf9268343cad7907$var$clearCustomOAuthSetup = function() {
    $bf9268343cad7907$var$customOAuthSetupId = '';
    window.sessionStorage.removeItem($bf9268343cad7907$var$CUSTOM_OAUTH_SETUP_STORAGE_KEY);
    (0, $12U9u.qS)('#custom_mcp_headers_section')?.classList.remove('hidden');
};
const $bf9268343cad7907$var$updateCustomAuthFields = function() {
    const authType = (0, $12U9u.qS)('#custom_mcp_auth_type')?.value || 'none';
    const bearer = authType === 'bearer';
    const oauth = authType === 'oauth';
    const oauthClientId = (0, $12U9u.qS)('#custom_mcp_oauth_client_id');
    const oauthClientSecret = (0, $12U9u.qS)('#custom_mcp_oauth_client_secret');
    (0, $12U9u.qS)('#custom_mcp_token_container')?.classList.toggle('hidden', !bearer);
    (0, $12U9u.qS)('#custom_mcp_oauth_fields')?.classList.toggle('hidden', !oauth);
    // OAuth keeps header values encrypted on the server across the redirect.
    (0, $12U9u.qS)('#custom_mcp_headers_section')?.classList.toggle('hidden', Boolean($bf9268343cad7907$var$customOAuthSetupId));
    (0, $12U9u.qS)('#custom_mcp_token').required = bearer;
    oauthClientSecret?.setCustomValidity(oauth && oauthClientSecret.value.trim() && !oauthClientId?.value.trim() ? (0, $4D2XJ.t)('plugins.customOAuthClientIdRequired') : '');
    if ((0, $12U9u.qS)('#custom_mcp_inspect')) (0, $12U9u.qS)('#custom_mcp_inspect').textContent = (0, $4D2XJ.t)(oauth ? 'plugins.customContinueOAuth' : 'plugins.customCheckConnection');
};
const $bf9268343cad7907$var$syncCustomConnectButton = function() {
    const connectButton = (0, $12U9u.qS)('#custom_mcp_connect');
    if (!connectButton) return;
    const allowedRowList = [
        ...document.querySelectorAll('.custom-mcp-tool-row')
    ].filter((row)=>row.querySelector('.custom-mcp-tool-permission')?.value === 'allowed');
    const hasAllowedUnspecifiedTool = allowedRowList.some((row)=>row.dataset.toolAccess === $bf9268343cad7907$var$CUSTOM_MCP_TOOL_ACCESS.UNSPECIFIED);
    const unspecifiedAccess = (0, $12U9u.qS)('input[name="custom_mcp_unspecified_access"]:checked')?.value || '';
    const unspecifiedAccessContainer = (0, $12U9u.qS)('#custom_mcp_unspecified_access');
    unspecifiedAccessContainer?.classList.toggle('hidden', !hasAllowedUnspecifiedTool);
    document.querySelectorAll('input[name="custom_mcp_unspecified_access"]').forEach((input)=>{
        input.required = hasAllowedUnspecifiedTool;
    });
    connectButton.disabled = allowedRowList.length === 0 || hasAllowedUnspecifiedTool && !unspecifiedAccess;
};
const $bf9268343cad7907$var$renderCustomToolList = function(toolList) {
    const list = (0, $12U9u.qS)('#custom_mcp_tool_list');
    list.innerHTML = '';
    toolList.forEach((tool)=>{
        const row = document.createElement('div');
        row.classList.add('custom-mcp-tool-row');
        row.dataset.toolName = tool.name;
        row.dataset.inputKey = $bf9268343cad7907$var$inferInputKey(tool);
        const declaredAccess = $bf9268343cad7907$var$getCustomMcpToolDeclaredAccess(tool);
        row.dataset.toolAccess = declaredAccess;
        const details = document.createElement('div');
        details.classList.add('custom-mcp-tool-details');
        const title = document.createElement('div');
        title.classList.add('title');
        title.textContent = tool.name;
        details.appendChild(title);
        if (tool.description) {
            const description = document.createElement('div');
            description.classList.add('description');
            description.textContent = tool.description;
            details.appendChild(description);
        }
        row.appendChild(details);
        const selectWrapper = document.createElement('div');
        selectWrapper.classList.add('select-wrapper');
        const select = document.createElement('select');
        select.classList.add('custom-mcp-tool-permission');
        [
            [
                'blocked',
                (0, $4D2XJ.t)('plugins.customDisallow')
            ],
            [
                'allowed',
                (0, $4D2XJ.t)('plugins.customAllow')
            ]
        ].forEach(([value, label])=>{
            const option = document.createElement('option');
            option.value = value;
            option.textContent = label;
            select.appendChild(option);
        });
        select.value = declaredAccess === $bf9268343cad7907$var$CUSTOM_MCP_TOOL_ACCESS.READ ? 'allowed' : 'blocked';
        select.addEventListener('change', $bf9268343cad7907$var$syncCustomConnectButton);
        selectWrapper.appendChild(select);
        row.appendChild(selectWrapper);
        list.appendChild(row);
    });
    (0, $12U9u.qS)('#custom_mcp_tool_review')?.classList.remove('hidden');
    (0, $12U9u.qS)('#custom_mcp_connect')?.classList.remove('hidden');
    $bf9268343cad7907$var$syncCustomConnectButton();
};
const $bf9268343cad7907$var$resetCustomInspection = function() {
    $bf9268343cad7907$var$customInspectionRevision += 1;
    (0, $12U9u.qS)('#custom_mcp_tool_review')?.classList.add('hidden');
    (0, $12U9u.qS)('#custom_mcp_connect')?.classList.add('hidden');
    if ((0, $12U9u.qS)('#custom_mcp_tool_list')) (0, $12U9u.qS)('#custom_mcp_tool_list').innerHTML = '';
    $bf9268343cad7907$var$syncCustomConnectButton();
};
const $bf9268343cad7907$var$setCustomFieldsEnabled = function(enabled) {
    [
        '#custom_mcp_endpoint',
        '#custom_mcp_auth_type',
        '#custom_mcp_token',
        '#custom_mcp_oauth_client_id',
        '#custom_mcp_oauth_client_secret'
    ].forEach((selector)=>{
        const field = (0, $12U9u.qS)(selector);
        if (field) field.disabled = !enabled;
    });
    document.querySelectorAll('#custom_mcp_headers_section input, #custom_mcp_headers_section button').forEach((field)=>{
        field.disabled = !enabled;
    });
    if (enabled) $bf9268343cad7907$var$syncCustomHeaderButton();
    const endpoint = (0, $12U9u.qS)('#custom_mcp_endpoint');
    if (endpoint) endpoint.required = enabled;
    const token = (0, $12U9u.qS)('#custom_mcp_token');
    if (token) token.required = enabled && (0, $12U9u.qS)('#custom_mcp_auth_type')?.value === 'bearer';
};
const $bf9268343cad7907$var$createCapabilityRow = function(copyText, type) {
    const row = document.createElement('div');
    row.classList.add('plugin-capability-row', `plugin-capability-${type}`);
    const icon = document.createElement('span');
    icon.classList.add('plugin-capability-icon');
    icon.setAttribute('aria-hidden', 'true');
    row.appendChild(icon);
    const content = document.createElement('div');
    const copy = document.createElement('div');
    copy.classList.add('copy');
    copy.textContent = copyText;
    content.appendChild(copy);
    row.appendChild(content);
    return row;
};
const $bf9268343cad7907$var$lowerFirst = function(value) {
    const text = String(value || '').trim();
    if ((0, $4D2XJ.getLanguage)() === 'de') return text;
    return text ? `${text.charAt(0).toLocaleLowerCase()}${text.slice(1)}` : '';
};
const $bf9268343cad7907$var$joinCapabilityList = function(capabilityList) {
    const itemList = capabilityList.map($bf9268343cad7907$var$lowerFirst).filter(Boolean);
    if (itemList.length < 2) return itemList[0] || '';
    if (itemList.length === 2) return itemList.join(` ${(0, $4D2XJ.t)('common.and')} `);
    return `${itemList.slice(0, -1).join(', ')}, ${(0, $4D2XJ.t)('common.and')} ${itemList.at(-1)}`;
};
const $bf9268343cad7907$var$fallbackCapabilitySentence = function(prefixKey, capabilityList, fallback) {
    const capabilityText = capabilityList.length ? $bf9268343cad7907$var$joinCapabilityList(capabilityList) : $bf9268343cad7907$var$lowerFirst(fallback);
    return (0, $4D2XJ.t)(prefixKey === 'plugins.cannot' ? 'plugins.capabilitiesBlocked' : 'plugins.capabilitiesAllowed', {
        capabilities: capabilityText
    });
};
const $bf9268343cad7907$var$renderAccessCapabilities = function() {
    const container = (0, $12U9u.qS)('#plugin_access_capabilities');
    if (!container || !$bf9268343cad7907$var$selectedPlugin || $bf9268343cad7907$var$selectedPlugin.custom) return;
    const allowWrite = (0, $12U9u.qS)('#plugin_access_write')?.checked === true;
    const readCapabilities = $bf9268343cad7907$var$selectedPlugin.readCapabilityList || [];
    const writeCapabilities = $bf9268343cad7907$var$selectedPlugin.writeCapabilityList || [];
    const capabilityCopy = $bf9268343cad7907$var$selectedPlugin.capabilityCopy || {};
    container.innerHTML = '';
    container.appendChild($bf9268343cad7907$var$createCapabilityRow(capabilityCopy.read || $bf9268343cad7907$var$fallbackCapabilitySentence('plugins.can', readCapabilities, (0, $4D2XJ.t)('plugins.readConnectedData')), 'allowed'));
    if (allowWrite && $bf9268343cad7907$var$selectedPlugin.supportsWrite) container.appendChild($bf9268343cad7907$var$createCapabilityRow(capabilityCopy.write || $bf9268343cad7907$var$fallbackCapabilitySentence('plugins.can', writeCapabilities, (0, $4D2XJ.t)('plugins.connectedData')), 'allowed'));
    else container.appendChild($bf9268343cad7907$var$createCapabilityRow($bf9268343cad7907$var$selectedPlugin.supportsWrite ? capabilityCopy.writeBlocked || $bf9268343cad7907$var$fallbackCapabilitySentence('plugins.cannot', writeCapabilities, (0, $4D2XJ.t)('plugins.connectedData')) : (0, $4D2XJ.t)('plugins.cannotChangeAnything'), 'blocked'));
};
const $bf9268343cad7907$var$renderSelectedSummary = function(pluginItem) {
    const summary = (0, $12U9u.qS)('#plugin_selected_summary');
    summary.innerHTML = '';
    summary.appendChild($bf9268343cad7907$var$createPluginLogo(pluginItem));
    const body = document.createElement('div');
    const title = document.createElement('div');
    title.classList.add('plugin-option-title');
    title.textContent = pluginItem.name;
    body.appendChild(title);
    const description = document.createElement('div');
    description.classList.add('plugin-option-description');
    description.textContent = pluginItem.description;
    body.appendChild(description);
    summary.appendChild(body);
};
const $bf9268343cad7907$var$selectPlugin = function(pluginItem) {
    $bf9268343cad7907$export$2c2cf027c588e49a();
    const previousPluginId = $bf9268343cad7907$var$selectedPlugin?.pluginId;
    $bf9268343cad7907$var$selectedPlugin = pluginItem;
    const nameInput = (0, $12U9u.qS)('#plugin_connection_name');
    if (previousPluginId !== pluginItem.pluginId || !nameInput.value.trim()) {
        const defaultName = pluginItem.custom ? '' : pluginItem.name;
        nameInput.value = defaultName;
        nameInput.dataset.defaultName = defaultName;
    }
    (0, $12U9u.qS)('#plugin_option_grid')?.classList.add('hidden');
    (0, $12U9u.qS)('#plugin_catalog_search')?.classList.add('hidden');
    (0, $12U9u.qS)('#plugin_selected_summary')?.classList.remove('hidden');
    (0, $12U9u.qS)('#plugin_selection_edit')?.classList.remove('hidden');
    (0, $12U9u.qS)('#plugin_details_form')?.classList.remove('hidden');
    (0, $12U9u.qS)('#plugin_fields_section')?.classList.remove('hidden');
    $bf9268343cad7907$var$renderSelectedSummary(pluginItem);
    const customSelected = pluginItem.custom === true;
    (0, $12U9u.qS)('#custom_mcp_fields')?.classList.toggle('hidden', !customSelected);
    (0, $12U9u.qS)('#plugin_access_fields')?.classList.toggle('hidden', customSelected);
    (0, $12U9u.qS)('#plugin_connect')?.classList.toggle('hidden', customSelected);
    (0, $12U9u.qS)('#custom_mcp_connect')?.classList.add('hidden');
    $bf9268343cad7907$var$setCustomFieldsEnabled(customSelected);
    $bf9268343cad7907$var$resetCustomInspection();
    if (customSelected) {
        $bf9268343cad7907$var$updateCustomAuthFields();
        (0, $12U9u.qS)('#custom_mcp_endpoint')?.focus();
        return;
    }
    const writeInput = (0, $12U9u.qS)('#plugin_access_write');
    writeInput.disabled = pluginItem.supportsWrite !== true;
    (0, $12U9u.qS)('label[for="plugin_access_write"]')?.classList.toggle('disabled', writeInput.disabled);
    (0, $12U9u.qS)('#plugin_access_read').checked = true;
    $bf9268343cad7907$var$renderAccessCapabilities();
    nameInput.focus();
    nameInput.select();
};
const $bf9268343cad7907$var$showPluginSelection = function() {
    $bf9268343cad7907$export$2c2cf027c588e49a();
    $bf9268343cad7907$var$clearCustomOAuthSetup();
    (0, $12U9u.qS)('#plugin_option_grid')?.classList.remove('hidden');
    (0, $12U9u.qS)('#plugin_catalog_search')?.classList.remove('hidden');
    (0, $12U9u.qS)('#plugin_selected_summary')?.classList.add('hidden');
    (0, $12U9u.qS)('#plugin_selection_edit')?.classList.add('hidden');
    (0, $12U9u.qS)('#plugin_details_form')?.classList.add('hidden');
    (0, $12U9u.qS)('#plugin_fields_section')?.classList.add('hidden');
};
const $bf9268343cad7907$var$renderPluginOption = function(pluginItem) {
    if (pluginItem.custom !== true && (pluginItem.active !== true || pluginItem.configured !== true)) return null;
    const option = document.createElement('div');
    option.classList.add('plugin-option');
    const input = document.createElement('input');
    input.type = 'radio';
    input.name = 'plugin_target';
    input.id = `plugin_target_${pluginItem.pluginId}`;
    input.value = pluginItem.pluginId;
    const label = document.createElement('label');
    label.htmlFor = input.id;
    label.appendChild($bf9268343cad7907$var$createPluginLogo(pluginItem));
    const body = document.createElement('div');
    const title = document.createElement('div');
    title.classList.add('plugin-option-title');
    title.textContent = pluginItem.name;
    body.appendChild(title);
    const description = document.createElement('div');
    description.classList.add('plugin-option-description');
    description.textContent = pluginItem.description;
    body.appendChild(description);
    label.appendChild(body);
    option.appendChild(input);
    option.appendChild(label);
    label.addEventListener('click', (event)=>{
        event.preventDefault();
        input.checked = true;
        $bf9268343cad7907$var$selectPlugin(pluginItem);
        (0, $e6rpZ.activity).log((0, $e6rpZ.activity).activityTypes.pluginView, (0, $20IIa.getPluginActivityMetadata)(pluginItem));
    });
    return option;
};
const $bf9268343cad7907$var$renderFilteredCatalog = function() {
    const grid = (0, $12U9u.qS)('#plugin_option_grid');
    if (!grid) return;
    const filteredList = (0, $knwcN.filterPluginCatalog)($bf9268343cad7907$var$pluginCatalog, (0, $12U9u.qS)('#plugin_catalog_search')?.value);
    grid.innerHTML = '';
    filteredList.forEach((pluginItem)=>{
        const option = $bf9268343cad7907$var$renderPluginOption(pluginItem);
        if (option) grid.appendChild(option);
    });
    if (!grid.childElementCount) {
        const empty = document.createElement('div');
        empty.classList.add('plugin-empty', 'list-text-sub', 'plugin-search-empty');
        empty.textContent = (0, $4D2XJ.t)('plugins.noSearchResults');
        grid.appendChild(empty);
    }
};
const $bf9268343cad7907$var$renderCatalog = async function({ preselectCustom: preselectCustom = false, pendingOAuthSetup: pendingOAuthSetup = null } = {}) {
    const grid = (0, $12U9u.qS)('#plugin_option_grid');
    grid.classList.remove('hidden');
    grid.innerHTML = `<div class="plugin-empty list-text-sub">${(0, $4D2XJ.t)('common.loading')}</div>`;
    try {
        const serverPluginList = await (0, $aWzLm.getPlugins)({
            force: true
        });
        $bf9268343cad7907$var$pluginCatalog = [
            ...(0, $hTT6T.buildCuratedPluginCatalog)((0, (/*@__PURE__*/$parcel$interopDefault($4BV0m))), serverPluginList, (0, $4D2XJ.getLanguage)()),
            {
                pluginId: $bf9268343cad7907$var$CUSTOM_PLUGIN_ID,
                name: (0, $4D2XJ.t)('plugins.customMcpTitle'),
                icon: 'custom',
                description: (0, $4D2XJ.t)('plugins.customDescription'),
                active: true,
                configured: true,
                custom: true,
                keywords: (0, $4D2XJ.t)('plugins.customSearchKeywords').split('|')
            }
        ];
        $bf9268343cad7907$var$renderFilteredCatalog();
        if (preselectCustom) {
            $bf9268343cad7907$var$selectPlugin($bf9268343cad7907$var$pluginCatalog.find((pluginItem)=>pluginItem.pluginId === $bf9268343cad7907$var$CUSTOM_PLUGIN_ID));
            if (pendingOAuthSetup) {
                const nameInput = (0, $12U9u.qS)('#plugin_connection_name');
                nameInput.value = pendingOAuthSetup.name || '';
                nameInput.dataset.defaultName = nameInput.value;
                (0, $12U9u.qS)('#custom_mcp_endpoint').value = pendingOAuthSetup.endpoint;
                (0, $12U9u.qS)('#custom_mcp_auth_type').value = 'oauth';
                (0, $12U9u.qS)('#custom_mcp_oauth_client_id').value = pendingOAuthSetup.oauthClientId || '';
                (0, $12U9u.qS)('#custom_mcp_oauth_client_secret').value = '';
                $bf9268343cad7907$var$customOAuthSetupId = pendingOAuthSetup.setupId;
                $bf9268343cad7907$var$updateCustomAuthFields();
                $bf9268343cad7907$var$renderCustomToolList(pendingOAuthSetup.toolList);
            }
        }
    } catch (error) {
        grid.replaceChildren();
        $bf9268343cad7907$export$2c2cf027c588e49a((0, $4D2XJ.t)('plugins.loadFailed'));
    }
};
const $bf9268343cad7907$var$resetPluginForm = function({ clearError: clearError = true } = {}) {
    if (clearError) $bf9268343cad7907$export$2c2cf027c588e49a();
    $bf9268343cad7907$var$selectedPlugin = null;
    $bf9268343cad7907$var$customOAuthSetupId = '';
    if ((0, $12U9u.qS)('#plugin_catalog_search')) (0, $12U9u.qS)('#plugin_catalog_search').value = '';
    const form = (0, $12U9u.qS)('#plugin_details_form');
    form?.reset();
    (0, $12U9u.qS)('#custom_mcp_header_list')?.replaceChildren();
    $bf9268343cad7907$var$syncCustomHeaderButton();
    form?.classList.add('hidden');
    (0, $12U9u.qS)('#plugin_fields_section')?.classList.add('hidden');
    (0, $12U9u.qS)('#plugin_selected_summary')?.classList.add('hidden');
    (0, $12U9u.qS)('#plugin_selection_edit')?.classList.add('hidden');
    (0, $12U9u.qS)('#plugin_catalog_search')?.classList.remove('hidden');
    (0, $12U9u.qS)('#custom_mcp_fields')?.classList.add('hidden');
    (0, $12U9u.qS)('#plugin_access_fields')?.classList.add('hidden');
    (0, $12U9u.qS)('#plugin_connect')?.classList.add('hidden');
    (0, $12U9u.qS)('#custom_mcp_token_container')?.classList.add('hidden');
    (0, $12U9u.qS)('#custom_mcp_oauth_fields')?.classList.add('hidden');
    $bf9268343cad7907$var$setCustomFieldsEnabled(false);
    $bf9268343cad7907$var$resetCustomInspection();
};

const $bf9268343cad7907$var$submitCustomPlugin = async function() {
    const connectButton = (0, $12U9u.qS)('#custom_mcp_connect');
    const toolSelectionList = [
        ...document.querySelectorAll('.custom-mcp-tool-row')
    ].map((row)=>({
            name: row.dataset.toolName,
            inputKey: row.dataset.inputKey,
            allowed: row.querySelector('.custom-mcp-tool-permission')?.value === 'allowed',
            declaredAccess: row.dataset.toolAccess
        }));
    const unspecifiedToolAccess = (0, $12U9u.qS)('input[name="custom_mcp_unspecified_access"]:checked')?.value || null;
    connectButton.classList.add('button-loading');
    connectButton.disabled = true;
    try {
        await (0, $aWzLm.createCustomPlugin)({
            ...$bf9268343cad7907$var$getCustomConnectionDetails(),
            toolSelectionList: toolSelectionList,
            unspecifiedToolAccess: unspecifiedToolAccess
        });
        $bf9268343cad7907$var$clearCustomOAuthSetup();
        $bf9268343cad7907$var$resetPluginForm();
        await $bf9268343cad7907$var$renderCatalog();
        const { renderPluginList: renderPluginList } = await (parcelRequire("3CEfb"));
        await renderPluginList();
    } catch (error) {
        console.error('Custom MCP connection failed:', error);
        $bf9268343cad7907$export$2c2cf027c588e49a($bf9268343cad7907$var$customConnectionErrorMessage(error) || (0, $4D2XJ.t)('plugins.customConnectFailed'));
        connectButton.classList.remove('button-loading');
        $bf9268343cad7907$var$syncCustomConnectButton();
    }
};

const $bf9268343cad7907$var$submitCuratedPlugin = async function() {
    const connectButton = (0, $12U9u.qS)('#plugin_connect');
    connectButton.classList.add('button-loading');
    connectButton.disabled = true;
    try {
        const result = await (0, $aWzLm.startPluginConnection)($bf9268343cad7907$var$selectedPlugin.pluginId, {
            name: (0, $12U9u.qS)('#plugin_connection_name')?.value || $bf9268343cad7907$var$selectedPlugin.name,
            allowWriteActions: (0, $12U9u.qS)('#plugin_access_write')?.checked === true
        });
        if (result.noAuth) {
            $bf9268343cad7907$var$resetPluginForm();
            await $bf9268343cad7907$var$renderCatalog();
            const { renderPluginList: renderPluginList } = await (parcelRequire("3CEfb"));
            await renderPluginList();
        }
    } catch (error) {
        $bf9268343cad7907$export$2c2cf027c588e49a(error.message || (0, $4D2XJ.t)('plugins.connectFailed'));
        connectButton.classList.remove('button-loading');
        connectButton.disabled = false;
    }
};
const $bf9268343cad7907$var$initPluginForm = function() {
    const form = (0, $12U9u.qS)('#plugin_details_form');
    const inspectButton = (0, $12U9u.qS)('#custom_mcp_inspect');
    const authType = (0, $12U9u.qS)('#custom_mcp_auth_type');
    (0, $12U9u.qS)('#custom_mcp_add_header')?.addEventListener('click', $bf9268343cad7907$var$addCustomHeaderRow);
    (0, $12U9u.qS)('#plugin_selection_edit')?.addEventListener('click', $bf9268343cad7907$var$showPluginSelection);
    (0, $12U9u.qS)('#plugin_catalog_search')?.addEventListener('input', $bf9268343cad7907$var$renderFilteredCatalog);
    (0, $12U9u.qS)('#plugin_access_read')?.addEventListener('change', $bf9268343cad7907$var$renderAccessCapabilities);
    (0, $12U9u.qS)('#plugin_access_write')?.addEventListener('change', $bf9268343cad7907$var$renderAccessCapabilities);
    document.querySelectorAll('input[name="custom_mcp_unspecified_access"]').forEach((input)=>{
        input.addEventListener('change', $bf9268343cad7907$var$syncCustomConnectButton);
    });
    authType?.addEventListener('change', ()=>{
        $bf9268343cad7907$var$clearCustomOAuthSetup();
        $bf9268343cad7907$var$updateCustomAuthFields();
        $bf9268343cad7907$var$resetCustomInspection();
    });
    [
        (0, $12U9u.qS)('#custom_mcp_endpoint'),
        (0, $12U9u.qS)('#custom_mcp_token'),
        (0, $12U9u.qS)('#custom_mcp_oauth_client_id'),
        (0, $12U9u.qS)('#custom_mcp_oauth_client_secret')
    ].forEach((input)=>{
        input?.addEventListener('input', ()=>{
            $bf9268343cad7907$var$clearCustomOAuthSetup();
            $bf9268343cad7907$var$updateCustomAuthFields();
            $bf9268343cad7907$var$resetCustomInspection();
        });
    });
    inspectButton?.addEventListener('click', async ()=>{
        $bf9268343cad7907$export$2c2cf027c588e49a();
        const details = $bf9268343cad7907$var$getCustomConnectionDetails();
        const revision = $bf9268343cad7907$var$customInspectionRevision;
        const endpointValid = (0, $12U9u.qS)('#custom_mcp_endpoint')?.reportValidity() !== false;
        const tokenValid = (0, $12U9u.qS)('#custom_mcp_token')?.reportValidity() !== false;
        const clientIdValid = (0, $12U9u.qS)('#custom_mcp_oauth_client_id')?.reportValidity() !== false;
        const clientSecretValid = (0, $12U9u.qS)('#custom_mcp_oauth_client_secret')?.reportValidity() !== false;
        if (!endpointValid || !tokenValid || !clientIdValid || !clientSecretValid || !$bf9268343cad7907$var$validateCustomHeaders()) return;
        inspectButton.classList.add('button-loading');
        inspectButton.disabled = true;
        try {
            if (details.authType === 'oauth') {
                await (0, $aWzLm.startCustomPluginOAuth)(details);
                return;
            }
            const result = await (0, $aWzLm.inspectCustomPlugin)(details);
            if (revision !== $bf9268343cad7907$var$customInspectionRevision) return;
            const nameInput = (0, $12U9u.qS)('#plugin_connection_name');
            if (result.serverName && nameInput.value === nameInput.dataset.defaultName) {
                nameInput.value = result.serverName;
                nameInput.dataset.defaultName = result.serverName;
            }
            $bf9268343cad7907$var$renderCustomToolList(result.toolList || []);
        } catch (error) {
            $bf9268343cad7907$export$2c2cf027c588e49a($bf9268343cad7907$var$customConnectionErrorMessage(error) || (0, $4D2XJ.t)('plugins.customCheckFailed'));
        } finally{
            inspectButton.classList.remove('button-loading');
            inspectButton.disabled = false;
        }
    });
    form?.addEventListener('submit', async (event)=>{
        event.preventDefault();
        $bf9268343cad7907$export$2c2cf027c588e49a();
        if (!$bf9268343cad7907$var$selectedPlugin || !form.reportValidity()) return;
        if ($bf9268343cad7907$var$selectedPlugin.custom) {
            if (!$bf9268343cad7907$var$validateCustomHeaders()) return;
            await $bf9268343cad7907$var$submitCustomPlugin();
            return;
        }
        await $bf9268343cad7907$var$submitCuratedPlugin();
    });
};
const $bf9268343cad7907$export$d5cdff876b53417 = function({ preselectCustom: preselectCustom = false } = {}) {
    const container = $bf9268343cad7907$export$fa22955b624062f4();
    if (!container) return;
    container.classList.toggle('hidden', (0, $ePZMh.viewingOtherUser)());
    if ((0, $ePZMh.viewingOtherUser)()) return;
    // OAuth callback errors are set during initialization, before this first render.
    $bf9268343cad7907$var$resetPluginForm({
        clearError: false
    });
    const pendingOAuthSetup = $bf9268343cad7907$var$getPendingCustomOAuthSetup();
    return $bf9268343cad7907$var$renderCatalog({
        preselectCustom: preselectCustom || Boolean(pendingOAuthSetup),
        pendingOAuthSetup: pendingOAuthSetup
    });
};

});
parcelRegister("hTT6T", function(module, exports) {

$parcel$export(module.exports, "buildCuratedPluginCatalog", () => $f96e209d34e5205a$export$71f293aa999701a4);
const $f96e209d34e5205a$export$31c70692ec725727 = function(plugin, serverItem = {}, language = 'en') {
    const german = language === 'de';
    return {
        ...serverItem,
        pluginId: plugin.id,
        toolkitSlug: plugin.toolkitSlug,
        name: plugin.name,
        icon: plugin.icon,
        description: german ? plugin.descriptionDe : plugin.description,
        keywords: plugin.keywords,
        capabilityCopy: {
            read: german ? plugin.readDescriptionDe : plugin.readDescription,
            write: german ? plugin.writeDescriptionDe : plugin.writeDescription,
            writeBlocked: german ? plugin.noWriteDescriptionDe : plugin.noWriteDescription
        },
        supportsWrite: plugin.supportsWrite !== false && serverItem.supportsWrite !== false,
        active: serverItem.active !== false,
        configured: serverItem.configured !== false,
        custom: false
    };
};
const $f96e209d34e5205a$export$71f293aa999701a4 = function(catalogPluginList = [], serverPluginList = [], language = 'en') {
    return catalogPluginList.map((plugin)=>$f96e209d34e5205a$export$31c70692ec725727(plugin, serverPluginList.find((serverItem)=>serverItem.pluginId === plugin.id) || {}, language)).filter((pluginItem)=>pluginItem.active === true && pluginItem.configured === true);
};

});

parcelRegister("knwcN", function(module, exports) {

$parcel$export(module.exports, "filterPluginCatalog", () => $82d5133ed2d50207$export$5daaf41b0c9e8dc);
const $82d5133ed2d50207$export$32db67120944b21d = function(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
};
const $82d5133ed2d50207$export$5daaf41b0c9e8dc = function(pluginCatalog = [], query = '') {
    const normalizedQuery = $82d5133ed2d50207$export$32db67120944b21d(query);
    return pluginCatalog.filter((pluginItem)=>{
        const haystack = $82d5133ed2d50207$export$32db67120944b21d([
            pluginItem?.name,
            pluginItem?.description,
            ...Array.isArray(pluginItem?.keywords) ? pluginItem.keywords : []
        ].join(' '));
        return !normalizedQuery || haystack.includes(normalizedQuery);
    });
};

});

parcelRegister("2EYvU", function(module, exports) {
const $1efe41f8997fc9b5$var$CUSTOM_MCP_TOOL_ACCESS = Object.freeze({
    READ: 'read',
    WRITE: 'write',
    UNSPECIFIED: 'unspecified'
});
const $1efe41f8997fc9b5$var$getCustomMcpToolDeclaredAccess = (tool = {})=>{
    if (tool.destructiveHint === true || tool.readOnlyHint === false) return $1efe41f8997fc9b5$var$CUSTOM_MCP_TOOL_ACCESS.WRITE;
    if (tool.readOnlyHint === true) return $1efe41f8997fc9b5$var$CUSTOM_MCP_TOOL_ACCESS.READ;
    if (typeof tool.destructiveHint === 'boolean') return $1efe41f8997fc9b5$var$CUSTOM_MCP_TOOL_ACCESS.WRITE;
    return $1efe41f8997fc9b5$var$CUSTOM_MCP_TOOL_ACCESS.UNSPECIFIED;
};
module.exports = {
    CUSTOM_MCP_TOOL_ACCESS: $1efe41f8997fc9b5$var$CUSTOM_MCP_TOOL_ACCESS,
    getCustomMcpToolDeclaredAccess: $1efe41f8997fc9b5$var$getCustomMcpToolDeclaredAccess
};

});

parcelRegister("7zs24", function(module, exports) {
const $58318bf3ac57373f$var$CUSTOM_MCP_MAX_HEADERS = 20;
const $58318bf3ac57373f$var$RESERVED_HEADERS = new Set([
    'authorization',
    'host',
    'content-length',
    'connection',
    'transfer-encoding',
    'accept',
    'accept-encoding',
    'content-type',
    'keep-alive',
    'te',
    'trailer',
    'upgrade',
    'expect',
    'origin',
    'referer',
    'cookie',
    'set-cookie',
    'mcp-session-id',
    'mcp-protocol-version',
    'last-event-id'
]);
// Shared by the form and backend. Never include user-supplied values in errors.
const $58318bf3ac57373f$var$normalizeCustomHeaders = (headerList = [])=>{
    if (!Array.isArray(headerList) || headerList.length > $58318bf3ac57373f$var$CUSTOM_MCP_MAX_HEADERS) throw new Error('CUSTOM_MCP_HEADERS_LIMIT');
    const entries = [];
    const names = new Set();
    let size = 0;
    for (const header of headerList){
        if (!header || typeof header.name !== 'string' || typeof header.value !== 'string') throw new Error('CUSTOM_MCP_HEADERS_INVALID');
        const name = header.name.trim().toLowerCase();
        const value = header.value.trim();
        if (!name && !value) continue;
        if (!/^[a-z0-9-]{1,100}$/.test(name) || !value || /[^\x20-\x7e\x80-\xff]/.test(header.value) || value.length > 8192) throw new Error('CUSTOM_MCP_HEADERS_INVALID');
        if ($58318bf3ac57373f$var$RESERVED_HEADERS.has(name) || /^(proxy-|sec-|mcp-)/.test(name)) throw new Error('CUSTOM_MCP_HEADERS_RESERVED');
        if (names.has(name)) throw new Error('CUSTOM_MCP_HEADERS_DUPLICATE');
        names.add(name);
        size += name.length + value.length;
        if (size > 16384) throw new Error('CUSTOM_MCP_HEADERS_LIMIT');
        entries.push([
            name,
            value
        ]);
    }
    return Object.fromEntries(entries);
};
module.exports = {
    CUSTOM_MCP_MAX_HEADERS: $58318bf3ac57373f$var$CUSTOM_MCP_MAX_HEADERS,
    normalizeCustomHeaders: $58318bf3ac57373f$var$normalizeCustomHeaders
};

});

parcelRegister("3CEfb", function(module, exports) {
module.exports = import("63thd").then(()=>parcelRequire('gA0pS'));

});




//# sourceMappingURL=appPluginRender.5bd8da87.js.map
